import { cn } from "@/utils/helpers";

interface LoaderProps {
  className?: string;
  ringClassName?: string;
  progress?: number;
  animate?: boolean;
  strokeWidth?: string;
}
const Loader = ({
  className,
  animate = true,
  strokeWidth = "30",
}: LoaderProps) => {
  return (
    <svg
      width="240"
      height="240"
      viewBox="0 0 240 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-[30px] text-co-accent", className)}
    >
      <defs>
        <linearGradient id="spinner-secondHalf">
          <stop offset="0%" stopOpacity="0" stopColor="currentColor" />
          <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
        </linearGradient>
        <linearGradient id="spinner-firstHalf">
          <stop offset="0%" stopOpacity="1" stopColor="currentColor" />
          <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
        </linearGradient>
      </defs>

      <g strokeWidth={strokeWidth}>
        <path
          stroke="url(#spinner-secondHalf)"
          d="M 20 120 A 100 100 0 0 1 220 120"
        />
        <path
          stroke="url(#spinner-firstHalf)"
          d="M 220 120 A 100 100 0 0 1 20 120"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          d="M 20 120 A 100 100 0 0 1 20 118"
        />
      </g>

      {animate && (
        <animateTransform
          from="0 0 0"
          to="-360 0 0"
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1300ms"
        />
      )}
    </svg>
  );
};

export default Loader;
